/**
 * Learning Gaps — GA for all orgs: the `learningGaps` org flag is no longer read.
 *
 * Gates nothing any more; the hook is kept (name + signature) so the call sites
 * that branch on it keep compiling. It covers the Learning Gaps half of the
 * admin dashboard: the Learning Gaps panel (teams → gaps → reports +
 * recommendations), Elliott's Recommended Course cards, the Teams filter, the
 * Learning Gaps Closed section and the "LEARNING DASHBOARD" chrome title.
 */
const useLearningGaps = (): boolean => true;

export default useLearningGaps;
